import { Expose, Type } from "class-transformer";

import { Beneficiary } from "src/shared/models/beneficiary.model";
import { PolicyPayment } from "src/shared/models/payment.model";
import { PolicyClient } from "src/shared/models/client.model";
import { PgaPolicy } from "src/shared/models/pga-policy.model";

export class PgaPolicyDetail extends PgaPolicy {
    @Expose() currency = "";

    @Expose() channel = "";

    @Expose() contractorId = -1;

    @Expose() holderId = -1;

    @Expose() insuredAmount = -1;

    @Expose() insuredCode = -1;

    @Expose() agentCode = -1;

    @Expose() digitalPolicy = false;

    @Expose() groupCode = "N/A";

    @Expose() renewalNumber: number | null = null;

    @Expose()
    @Type(() => PolicyPayment)
    payment: PolicyPayment = new PolicyPayment();

    @Expose() contractor?: PolicyClient;

    @Expose() holder?: PolicyClient;

    @Expose() beneficiaries?: Beneficiary[];
}
